import { loadScenarioFromJsonPayload, type EgoCrisisScenario } from './storyLoader';

/* eslint-disable @typescript-eslint/no-var-requires */
const shadowAndLightStoryJson = require('./shadow_and_light-v2.story.json');
/* eslint-enable @typescript-eslint/no-var-requires */

export type ArchitectureUnderFireScenario = EgoCrisisScenario;

export const architectureUnderFireScenario: ArchitectureUnderFireScenario =
  loadScenarioFromJsonPayload(
    {
      id: 'architecture-under-fire',
      title: 'Architecture Under Fire',
      subtitle: 'Les Frontières Hybrides',
      certification: 'AZ-700',
      coverImage: require('../../../assets/images/missions/architecture_under_fire.png'),
    },
    shadowAndLightStoryJson,
  );

export default architectureUnderFireScenario;
